const urlSearchParamsToPlain = (urlSearchParams: URLSearchParams): Record<string, string> => Object.fromEntries(urlSearchParams);

export default urlSearchParamsToPlain;
